import {
    APPLICATION_FORM_FIELDS,
    APPLICATION_OPPONENT_ENUM,
    DATE_OF_FEE_AGREEMENT_TRIGGER_TOTAL_WEEKS,
    DATE_AWARE_TRIGGER_TOTAL_WEEKS
} from "../variables";
import moment from "moment";
import _ from "lodash";

export const getTopLevelQuestion = (initialQuestion, questions) => {
    if (initialQuestion.isParent) {
        return initialQuestion;
    }
    let found = null;

    questions.forEach(question => {
        const match = findDeepQuestion(question, initialQuestion.id);
        if (match) {
            found = question;
        }

    });

    return found;
};

const findDeepQuestion = (rootQuestion, desiredQuestionId) => {
    if (rootQuestion.id === desiredQuestionId) {
        return rootQuestion;
    }
    let found = null;

    rootQuestion.options.forEach(option => {

        option.childQuestions.forEach(childQuestion => {

            const match = findDeepQuestion(childQuestion, desiredQuestionId);
            if (match) {
                found = match;
            }

        })

    });

    return found;
};

export const checkIfQuestionHasPendingAnswers = (questionId, questionsAnswers) => {
    if (!questionId || !questionsAnswers || !questionsAnswers.length) {
        return false;
    }

    return !!questionsAnswers.find(q =>
        q.questionId
        && q.questionId.toString() === questionId.toString()
        && q.hasPendingChanges
    );

};

// flattens questions objects that contain nested questions
export const flattenQuestions = (questions) => {
    let flattened = [];
    questions.forEach(question => {
        flattened = [...flattened, question];
        question.options.forEach(option => {
            flattened = [...flattened, ...flattenQuestions(option.childQuestions)];
        });
    });
    return flattened;
};
// flattens question objects that contain nested questions
export const flattenQuestion = (question) => {
    let flattened = [];
        flattened = [...flattened, question];
        question.options.forEach(option => {
            flattened = [...flattened, ...flattenQuestions(option.childQuestions)];
        });
    return flattened;
};

//
/**
 * gets the question answers based on it (the question can either be a app question, app field)
 * application withs answers is expected as an argument
 * @param {object} question - The question object.
 * @param {object} application - The full application dto.
 */
export const getQuestionAnswer = (question, application) => {
    if (!question) {
        return "";
    }

    // check if question is of type field
    if (question.machineName === APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fakeQuestion.machineName) {
        return application.solicitorReference
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.CLIENT_NAME.fakeQuestion.machineName) {
        return application.clientName
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.ADDRESS.fakeQuestion.machineName) {
        return application.address
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.POST_CODE.fakeQuestion.machineName) {
        return application.postCode
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fakeQuestion.machineName) {
        return (application.dateOfBirth ? moment(application.dateOfBirth).format("DD/MM/YYYY") : "")
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.WORK_SOURCE.fakeQuestion.machineName) {
        return application.workSourceId;
    }

    // answer for question medical expert fees
    if (question.machineName === "EstimateForMedicalExpertFees") {

    }

    // answer for regural question
    if (question.machineName !== "EstimateForMedicalExpertFees" && question.machineName !== "OpponentName") {
        const answerItem = application.applicationAnswersDtos.find(a => a.questionId.toString() === question.id.toString());

        return mapAnswerItemToValue(answerItem, question)
    }
};

/**
 * gets the question answers based on it (the question can either be a app question, app field)
 * @param {object} question - The question object.
 * @param {object} pendingChange - The pending change dto.
 * @param {object} application - The full application dto.
 */
export const getPendingQuestionAnswer = (question, pendingChange, application) => {
    if (!question) {
        return "";
    }

    // check if question is of type field
    if (question.machineName === APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fakeQuestion.machineName) {
        return pendingChange.applicationAnswerPendingChangeItemDtos[0].text;
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.CLIENT_NAME.fakeQuestion.machineName) {
        return pendingChange.applicationAnswerPendingChangeItemDtos[0].text;
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.ADDRESS.fakeQuestion.machineName) {
        return pendingChange.applicationAnswerPendingChangeItemDtos[0].text;
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.POST_CODE.fakeQuestion.machineName) {
        return pendingChange.applicationAnswerPendingChangeItemDtos[0].text;
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fakeQuestion.machineName) {
        return (pendingChange.applicationAnswerPendingChangeItemDtos[0].date ?
            moment(pendingChange.applicationAnswerPendingChangeItemDtos[0].date).format("DD/MM/YYYY") : "")
    }

    if (question.machineName === APPLICATION_FORM_FIELDS.WORK_SOURCE.fakeQuestion.machineName) {
        return pendingChange.applicationAnswerPendingChangeItemDtos[0].referenceEntityId
    }

    // answer for regural question
    if (question.machineName !== "EstimateForMedicalExpertFees" && question.machineName !== "OpponentName") {
        const currentAnswer = application.applicationAnswersDtos.find(a => a.questionId.toString() === question.id.toString());
        return mapPendingAnswerItemToValue(pendingChange, currentAnswer, question)
    }

    return "";
};

/**
 * @param {object} answer - The question answer.
 * @param {object} question - The question.
 */
export const mapAnswerItemToValue = (answer, question) => {
    if (!answer) {
        return '';
    }

    if (answer.date) {
        return moment(answer.date).format("DD/MM/YYYY");
    }

    if (answer.amount) {
        return answer.amount;
    }

    if (answer.text) {
        return answer.text;
    }

    if (answer.optionId) {
        return answer.optionId;
    }
};

/**
 * @param {object} revision - The question answer.
 * @param {object} question - The question.
 */
export const mapRevisionItemToValue = (revision, question) => {
    if (!revision) {
        return null;
    }

    if (revision.date) {
        return moment(revision.date).format("DD/MM/YYYY");
    }

    if (revision.amount) {
        return revision.amount;
    }

    if (revision.text) {
        return revision.text;
    }

    if (revision.optionId) {
        return revision.optionId;
    }

    if (revision.referenceEntityId) {
        return revision.referenceEntityId;
    }
};

/**
 * @param {object} pendingChange - The question answer.
 * @param {object} currentAnswer - The question answer.
 * @param {object} question - The question.
 */
export const mapPendingAnswerItemToValue = (pendingChange, currentAnswer, question) => {
    if (!pendingChange || !question) {
        return null;
    }

    const pendingAnswerItem = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.questionId === question.id);

    if (pendingAnswerItem && pendingAnswerItem.date) {
        return moment(pendingAnswerItem.date).format("DD/MM/YYYY");
    }

    if (pendingAnswerItem && pendingAnswerItem.amount) {
        return pendingAnswerItem.amount;
    }

    if (pendingAnswerItem && pendingAnswerItem.text) {
        return pendingAnswerItem.text;
    }

    if (pendingAnswerItem && pendingAnswerItem.optionId) {
        return pendingAnswerItem.optionId;
    }

    return mapAnswerItemToValue(currentAnswer, question)
};


/**
 * maps the child questions of the given question
 * @param {object} question - The question.
 */
export const getChildQuestions = (question) => {
    let items = [];
    if (!question || !question.options) {
        return [];
    }

    _.forEach(question.options, option => {
        _.forEach(option.childQuestions, childQuestion => {
            items.push(childQuestion);
            items = [...items, ...getChildQuestions(childQuestion)]
        })
    });
    return items;
};

/**
 * maps the FIRST LEVEL child questions of the given question
 * @param {object} question - The question.
 */
export const getFirstLevelQuestionTree = (question) => {
    let items = [];
    if (!question || !question.options) {
        return [];
    }
    items.push(question);

    _.forEach(question.options, option => {
        _.forEach(option.childQuestions, childQuestion => {
            items.push(childQuestion);
        })
    });
    return items;
};


/**
 * @param {object} question - The question object.
 * @param {object} application - The full application dto.
 */
export const getAnswersOfQuestionAndItsAncestors = (question, application) => {
    if (!question || !application) {
        return {};
    }

    let answers = {};
    const flattenedQuestions = [question, ...getChildQuestions(question)];
    flattenedQuestions.forEach(question => {
        answers = {
            ...answers,
            [question.id]: getQuestionAnswer(question, application)
        }
    });

    return answers;
};

/**
 * @param {object} application - The full application dto.
 */
export const getAnswersOfApplication = (application) => {
    if (!application) {
        return {};
    }

    let answers = {};
    const flattenedQuestions = flattenQuestions(application.questionsDtos);
    flattenedQuestions.forEach(question => {
        answers = {
            ...answers,
            [question.id]: getQuestionAnswer(question, application)
        }
    });

    return answers;
};

/**
 * Find question that has the given option id
 * @param {array} questions - The questions with their sub questions.
 * @param {number, string} optionId - The option id.
 */
export const getQuestionFromOptionId = (questions, optionId) => {
    if (!questions || !optionId) {
        return {};
    }

    let foundQuestion = {};
    const flattenedQuestions = flattenQuestions(questions);
    flattenedQuestions.forEach(question => {
        const found = question.options.find(option => optionId.toString() === option.id.toString());
        if (found) {
            foundQuestion = found;
        }
    });

    return foundQuestion;
};

/**
 * @param {object} question - The question object.
 * @param {object} pendingChange - The full pending change dto.
 * @param {object} application - The full application dto.
 */
export const getPendingAnswersOfQuestionAndItsAncestors = (question, pendingChange, application) => {
    if (!question || !pendingChange) {
        return {};
    }

    let answers = {};
    const flattenedQuestions = [question, ...getChildQuestions(question)];
    flattenedQuestions.forEach(question => {
        answers = {
            ...answers,
            [question.id]: getPendingQuestionAnswer(question, pendingChange, application)
        }
    });

    return answers;
};

/**
 * @param {number|string} opponentId - The opponent id.
 * @param {object} application - The full application dto.
 */
export const getAnswersOFOpponentQuestionGroup = (opponentId, application) => {
    if (!opponentId || !application) {
        return {};
    }

    const foundOpponent = application.applicationOpponents.find(opp => (
        opp.id
        && opponentId
        && opp.id.toString() === opponentId.toString()
    ));

    if (!foundOpponent) {
        return {};
    }
    const prospectsAnswer = application.applicationAnswersDtos.find(dto => dto.id === foundOpponent.prospectsAnswerId);
    const insuredAnswer = application.applicationAnswersDtos.find(dto => dto.id === foundOpponent.insuredAnswerId);
    const satisfiedAnswer = application.applicationAnswersDtos.find(dto => dto.id === foundOpponent.satisfiedAnswerId);
    const insurerAnswer = application.applicationAnswersDtos.find(dto => dto.id === foundOpponent.insurerAnswerId);
    const otherInsurerAnswer = application.applicationAnswersDtos.find(dto => dto.id === foundOpponent.otherInsurerAnswerId);
    return {
        id: foundOpponent.id,
        name: foundOpponent.name,
        prospectsOptionId: prospectsAnswer ? prospectsAnswer.optionId ? prospectsAnswer.optionId.toString() : "" : "",
        insuredOptionId: insuredAnswer ? insuredAnswer.optionId ? insuredAnswer.optionId.toString() : "" : "",
        satisfiedOptionId: satisfiedAnswer ? satisfiedAnswer.optionId ? satisfiedAnswer.optionId.toString() : "" : "",
        insurerOptionId: insurerAnswer ? insurerAnswer.optionId ? insurerAnswer.optionId.toString() : "" : "",
        otherInsurerId: otherInsurerAnswer ? otherInsurerAnswer.id : "",
        otherInsurerName: otherInsurerAnswer ? otherInsurerAnswer.text : "" ,
        };
};

/**
 * @param {string} opponentQuestionMachineName - The opponent question machine name.
 * @param {object} opponent - The opponent object dto
 */
export const getOpponentQuestionValue = (opponentQuestionMachineName, opponent) => {
    if (opponentQuestionMachineName === 'ProspectsAgainstOpponent') return opponent.prospectsOptionId;
    if (opponentQuestionMachineName === 'IsOpponentInsured') return opponent.insuredOptionId;
    if (opponentQuestionMachineName === 'OpponentNotInsuredSatisfiedHasFunds') return opponent.satisfiedOptionId;
    if (opponentQuestionMachineName === 'OpponentDoNotKnowInsuredSatisfiedHasFunds') return opponent.satisfiedOptionId;
    if (opponentQuestionMachineName === 'WhoIsTheInsurer') return opponent.insurerOptionId;
    if (opponentQuestionMachineName === 'NameOfInsurerOther') return opponent.otherInsurerName;

    return ''
};

/**
 * @param {number|string} expertFeesId - The medical expert fee id.
 * @param {object} application - The full application dto.
 */
export const getAnswersOfMedicalExpertFeesQuestion = (expertFeesId, application) => {
    if (!expertFeesId || !application) {
        return {};
    }

    const foundExpertFees = application.applicationMedicalExpertFees.find(fee => (
        fee.id
        && expertFeesId
        && fee.id.toString() === expertFeesId.toString()
    ));

    if (!foundExpertFees) {
        return {};
    }

    return {
        id: foundExpertFees.id,
        name: foundExpertFees.name,
        natureOfExpert: foundExpertFees.natureOfExpert,
        whySpecificExpert: foundExpertFees.whySpecificExpert,
        breachCausationCpId: foundExpertFees.breachCausationCpId,
        partialEstimatedCost: foundExpertFees.partialEstimatedCost,
        attendanceEstimatedCost: foundExpertFees.attendanceEstimatedCost,
    };
};

/**
 * @param {number|string} opponentId - The opponent id.
 * @param {object} pendingChange - The full pending change dto.
 * @param {object} application - The full application dto.
 */
export const getPendingAnswersOFOpponentQuestionGroup = (opponentId, pendingChange, application) => {
    if (!pendingChange) {
        return {};
    }

    const currentOpponentAnswer = getAnswersOFOpponentQuestionGroup(opponentId, application);
    const nameAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "Name");
    const prospectsAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "ProspectsId");
    const insuredAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "InsuredId");
    const satisfiedAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "SatisfiedId");
    const insurerAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "InsurerId");
    const otherInsurerNameAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "OtherInsurerName");

    return {
        id: currentOpponentAnswer.id,
        name: nameAnswer ? nameAnswer.text : currentOpponentAnswer.name,
        prospectsOptionId: prospectsAnswer && prospectsAnswer.referenceEntityId ?
            prospectsAnswer.referenceEntityId.toString() : currentOpponentAnswer.prospectsOptionId,
        insuredOptionId: insuredAnswer && insuredAnswer.referenceEntityId ?
            insuredAnswer.referenceEntityId.toString() : currentOpponentAnswer.insuredOptionId,
        satisfiedOptionId: satisfiedAnswer && satisfiedAnswer.referenceEntityId ?
            satisfiedAnswer.referenceEntityId.toString() : currentOpponentAnswer.satisfiedOptionId,
        insurerOptionId: insurerAnswer && insurerAnswer.referenceEntityId ?
            insurerAnswer.referenceEntityId.toString() : currentOpponentAnswer.insurerOptionId,
        otherInsurerName: otherInsurerNameAnswer ? otherInsurerNameAnswer.text : currentOpponentAnswer.otherInsurerName,
    };
};

/**
 * @param {number|string} expertFeesId - The medical expert fee id.
 * @param {object} pendingChange - The full pending change dto.
 * @param {object} application - The full application dto.
 */
export const getPendingAnswersOfMedicalExpertFeesQuestion = (expertFeesId, pendingChange, application) => {
    if (!application) {
        return {};
    }

    const currentAnswer = getAnswersOfMedicalExpertFeesQuestion(expertFeesId, application);

    const nameAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "Name");
    const natureOfExpertAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "NatureOfExpert");
    const whySpecificExpertAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "WhySpecificExpert");
    const breachCausationCpIdAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "BreachCausationCpId");
    const partialEstimatedCostAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "PartialEstimatedCost");
    const attendanceEstimatedCostAnswer = pendingChange.applicationAnswerPendingChangeItemDtos.find(dto => dto.columnName === "AttendanceEstimatedCost");

    return {
        id: currentAnswer.id,
        name: nameAnswer && nameAnswer.text ?
            nameAnswer.text : currentAnswer.name,
        natureOfExpert: natureOfExpertAnswer && natureOfExpertAnswer.text ?
            natureOfExpertAnswer.text : currentAnswer.natureOfExpert,
        whySpecificExpert: whySpecificExpertAnswer && whySpecificExpertAnswer.text ?
            whySpecificExpertAnswer.text : currentAnswer.whySpecificExpert,
        breachCausationCpId: breachCausationCpIdAnswer && breachCausationCpIdAnswer.referenceEntityId ?
            breachCausationCpIdAnswer.referenceEntityId : currentAnswer.breachCausationCpId,
        partialEstimatedCost: partialEstimatedCostAnswer && partialEstimatedCostAnswer.amount ?
            partialEstimatedCostAnswer.amount : currentAnswer.partialEstimatedCost,
        attendanceEstimatedCost: attendanceEstimatedCostAnswer && attendanceEstimatedCostAnswer.amount ?
            attendanceEstimatedCostAnswer.amount : currentAnswer.attendanceEstimatedCost,
    };
};

/**
 * @param {number|string} entityId - The question id
 * @param {object} application - The application dto.
 * @param {string} type - The type (field, opponent, medicalExpertFees)
 */
export const checkIfQuestionHasPendingChanges = (entityId, application, type) => {
    if (!application || !application.id) {
        return false;
    }

    if (
        type
        && type === "EstimateForMedicalExpertFees"
        && application.applicationMedicalExpertFees.find(item => item.pendingChangesFields.length > 0)
    ) {
        return true;
    }

    if (
        type
        && type === "OpponentName"
        && entityId
        && application.applicationOpponents.find(item => (
            item.id
            && item.pendingChangesFields.length > 0
            && item.id.toString() === entityId.toString()
        ))
    ) {
        return true;
    }

    if (
        type
        && (
            type === APPLICATION_FORM_FIELDS.ADDRESS.fieldName
            || type === APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName
            || type === APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName
            || type === APPLICATION_FORM_FIELDS.POST_CODE.fieldName
            || type === APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName
            || type === APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName
        )
        && application.pendingChangesFields.find(i => i === type)
    ) {
        return true;
    }

    if (entityId) {
        const found = application.applicationAnswersDtos.find(answer => (
            answer.questionId
            && answer.questionId.toString() === entityId.toString()
        ));
        return found && found.hasPendingChanges
    }

    return false
};

/**

 * @param {string} type - The type (field, opponent, medicalExpertFees)
 * @param {string=} opponentQuestionMachineName - The opponent question machine name
 */
export const checkIfQuestionsHasBeenModified = (entityId, application, type, opponentQuestionMachineName) => {
    if (!application) {
        return false;
    }

    if (
        type
        && type === "EstimateForMedicalExpertFees"
        && application.applicationMedicalExpertFees.find(item => (
            item.id
            && item.modifiedFields.length > 0
            && item.id.toString() === entityId.toString()
        ))
    ) {
        return true;
    }

    if (
        type
        && type === "OpponentName"
        && entityId
        && application.applicationOpponents.find(item => (
            item.id
            && item.id.toString() === entityId.toString()
            && item.modifiedFields.length > 0
            && APPLICATION_OPPONENT_ENUM[opponentQuestionMachineName]
            && item.modifiedFields.includes(APPLICATION_OPPONENT_ENUM[opponentQuestionMachineName])
        ))
    ) {
        return true;
    }

    if (
        type
        && (
            type === APPLICATION_FORM_FIELDS.ADDRESS.fieldName
            || type === APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName
            || type === APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName
            || type === APPLICATION_FORM_FIELDS.POST_CODE.fieldName
            || type === APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName
            || type === APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName
        )
        && application.modifiedFields.find(i => i === type)
    ) {
        return true;
    }

    if (entityId) {
        const found = application.applicationAnswersDtos.find(answer => (
            answer.questionId
            && answer.questionId.toString() === entityId.toString()
        ));
        return found && found.hasBeenModified
    }

    return false
};


// expects the questions to be flat
export const findQuestionByMachineName = (machineName, questions) => {
    return questions.find(q => q.machineName === machineName);
};

// expects the questions to be flat
export const findQuestionById = (questionId, questions) => {
    return questions.find(q =>
        questionId
        && q.id
        && q.id.toString() === questionId.toString()
    );
};

export const getDateQuestionMinimumValue = (question, policyFormData, questions) => {
    let minimumValue;

    if (question.minimumValue === "now") {
        minimumValue = moment().format('DD/MM/YYYY');
    } else if (question.minimumValue === "yesterday") {
        minimumValue = moment().subtract(1, 'day').format('DD/MM/YYYY');
    } else if (question.minimumValue === "tomorrow") {
        minimumValue = moment().add(1, 'day').format('DD/MM/YYYY');
    } else {
        const found = questions.find(q => q.machineName === question.minimumValue);
        minimumValue = found ? policyFormData[found.id] : minimumValue;
    }

    if (minimumValue) {
        if (question.minimumValue === "now") {
            return moment().format('DD/MM/YYYY');
        } else {
            return minimumValue;
        }
    } else return '';
};

export const getDateQuestionMaximumValue = (question, policyFormData, questions) => {
    let allMaximumValues = [];
    const exploded = question.maximumValue ? question.maximumValue.split(",") : [];

    exploded.forEach(maximumValue => {
        let max;
        if (maximumValue === "now") {
            max = moment().format('DD/MM/YYYY');
        } else if (question.maximumValue === "yesterday") {
            max = moment().subtract(1, 'day').format('DD/MM/YYYY');
        } else if (question.maximumValue === "tomorrow") {
            max = moment().add(1, 'day').format('DD/MM/YYYY');
        } else {
            const found = questions.find(q => q.machineName === maximumValue);
            max = found ? policyFormData[found.id] : maximumValue;
        }

        if (max) {
            allMaximumValues.push(max);
        }

    });

    return allMaximumValues.length > 0 ? moment.min(
        allMaximumValues.map(i => moment(i, "DD/MM/YYYY"))
    ).format("DD/MM/YYYY") : '';
};

export const getTriggeredQuestionFromQuestionsMayBeTriggered = (formData, triggeredQuestions,allquestions) => {
    let questions = [];
    triggeredQuestions.forEach(q => {
        if (q.questionDisplaySettings != null) {
            if (q.questionDisplaySettings.some(qq =>
                qq.conditions.every(c =>
                    checkConditionFromTriggeredQuestion(formData,allquestions, c)
                )
            )) {
                questions.push(q);
            }
        }
    })
    return questions;
};

export const getTriggeredQuestion = (formData, questions, singleQuestion) => {
    if (questions && singleQuestion) {
        let question = questions.find(q => q.id === singleQuestion.id);
        if (question) {
            if (question.questionDisplaySettings !== null) {
                if (question.questionDisplaySettings.some(qq =>
                    qq.conditions.every(c =>
                        checkConditionFromTriggeredQuestion(formData,questions, c)
                    )
                )) {
                    return question
                }
            }
        }
    }
    return null;
};

export const checkQuestionsMayBetriggered = (prevFormData, currentFormData, questions) => {
    let changedQuestion = []
    let questionsMayBeTriggered = []
    if (Object.keys(prevFormData).length > 0 &&
        Object.keys(currentFormData).length > 0) {
        const allkeys = _.union(_.keys(prevFormData), _.keys(currentFormData));
        _.reduce(allkeys, function (result, key) {
            if (!_.isEqual(prevFormData[key], currentFormData[key])) {
                changedQuestion = [...changedQuestion, key]
            }
            return changedQuestion;
        }, {});
        if (changedQuestion.length > 0) {
            Object.keys(questions).map(q => {
                if (changedQuestion.some(item => questions[q].includes(parseInt(item)))) {
                    questionsMayBeTriggered = [...questionsMayBeTriggered, q]
                }
            });
            return questionsMayBeTriggered.map(x => parseInt(x))
        } else {
            return []
        }
    }
    return []
};

export const findQuestionsTriggeredByQuestions = (questions) => {
    return questions.filter(x => x.questionDisplaySettings !== null);

}

export const createObjectWithPropertyTriggeredQuestionsAndValuesQuestionsThatTriggerThem = (questions) => {
    let questionIds = {};
    questions.forEach(q => {
        q.questionDisplaySettings.forEach(qq => {
            qq.conditions.forEach(c => {
                if (questionIds[q.id]) {
                    questionIds = {
                        ...questionIds,
                        [q.id]: [...questionIds[q.id], ...c.triggeredByQuestionIds]
                    }
                } else {
                    questionIds = {
                        ...questionIds,
                        [q.id]: [...c.triggeredByQuestionIds]
                    }
                }
            })
        })
    })
    return questionIds;
}
export const checkConditionFromTriggeredQuestion = (formData,questions, condition) => {
    if (condition.conditionType === "MoreOrEqualFromDifferenceByWeeksBetweenNowAndDateQuestion") {
        let minValue = Math.max(condition.value.map(v => parseInt(v)));
        return moment(moment(), "DD/MM/YYYY")
            .diff(moment(formData[condition.triggeredByQuestionIds[0]], "DD/MM/YYYY"), "weeks") >= minValue
    }

    if (condition.conditionType === "HasValue") {
        let triggeredQuestion = questions.find(x=> x.id === condition.triggeredByQuestionIds[0])
        if(triggeredQuestion==undefined)
        {
          return null;  
        }
        
        const option = triggeredQuestion.options.find(opt=>opt.id.toString() === formData[condition.triggeredByQuestionIds[0]]?.toString())
        if(option){
        return condition.value.includes(option.machineName);
        }
    return false
    }

    if (condition.conditionType === "MoreFromDifferenceByWeeksBetweenDateQuestions") {
        let minValue1 = Math.max(condition.value.map(v => parseInt(v)));
        return moment(formData[condition.triggeredByQuestionIds[0]], "DD/MM/YYYY")
            .diff(moment(formData[condition.triggeredByQuestionIds[1]], "DD/MM/YYYY"), "weeks") > minValue1

    }
    if (condition.conditionType === "MoreOrEqualFromDifferenceByWeeksBetweenDateQuestions") {
        let minValue1 = Math.max(condition.value.map(v => parseInt(v)));
        return moment(formData[condition.triggeredByQuestionIds[0]], "DD/MM/YYYY")
            .diff(moment(formData[condition.triggeredByQuestionIds[1]], "DD/MM/YYYY"), "weeks") >= minValue1

    }

    return false
}

export const arrayUnique=(array) => {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }

    return a;
  }


export const readQuestionDisplaySettings = (settings,allquestions) =>
{  
    var requiredIfText = "";
    settings.forEach(s => {
        s.conditions.forEach((c, index) => {
            const moreThanOneCondition = index > 0 ? true : false;
            switch (c.conditionType) {

                case "MoreOrEqualFromDifferenceByWeeksBetweenNowAndDateQuestion":
                    var question = allquestions.find(q => q.id == c.triggeredByQuestionIds[0])
                    requiredIfText += (moreThanOneCondition ? " & " : "\n• ") + question.machineName + " is " + c.value[0] + " weeks or more before current date";
                    break;

                case "HasValue":
                    var question = allquestions.find(q => q.id == c.triggeredByQuestionIds[0])
                    requiredIfText += (moreThanOneCondition ? " & " : "\n• ") + c.value.map((v, moreThanOneValue) => (moreThanOneValue > 0 ? " or " : "") + question.machineName + " = " + v);

                    break;

                case "MoreFromDifferenceByWeeksBetweenDateQuestions":
                    var firstQuestion = allquestions.find(q => q.id == c.triggeredByQuestionIds[0])
                    var secondQuestion = allquestions.find(q => q.id == c.triggeredByQuestionIds[1])
                    requiredIfText += (moreThanOneCondition ? " & " : "\n• ") + firstQuestion.machineName + " is more than " + c.value[0] + " weeks after " + secondQuestion.machineName;
                    break;

                case "MoreOrEqualFromDifferenceByWeeksBetweenDateQuestions":
                    var firstQuestion = allquestions.find(q => q.id == c.triggeredByQuestionIds[0])
                    var secondQuestion = allquestions.find(q => q.id == c.triggeredByQuestionIds[1])
                    requiredIfText += (moreThanOneCondition ? " & " : "\n• ") + firstQuestion.machineName + " is more or equal than " + c.value[0] + " weeks after " + secondQuestion.machineName;
                    break;


                default:
                    requiredIfText = "";
            }
        })

    });
    return requiredIfText;
}

export const checkWhichQuestionTriggeredConditional = (formData,questions, conditionalQuestion) =>
{  
    var triggerQuestionsGroupIds = [];
    
    conditionalQuestion.questionDisplaySettings.forEach(qq =>
        qq.conditions.forEach(condition => {
          if (checkConditionFromTriggeredQuestion(formData, questions, condition)) {
            condition.triggeredByQuestionIds.forEach(id => {
              const triggeredQuestion = questions.find(x => x.id === id);
              if (triggeredQuestion) {
                triggerQuestionsGroupIds.push(triggeredQuestion.groupId);
              }
            });
          }
        })
      );
    
    return arrayUnique(triggerQuestionsGroupIds);
}